import React from 'react'
import './LoaderCe.scss'
import { useLoader } from '../../context/LoaderContext'
import ImgLoader from '../../assets/img/cubiertos_loader.gif'


const LoaderCe = () => {
    const {loading} = useLoader();

    return loading ?
    <>
        <div className='ce-als-loader-bg'></div>
        <div className='ce-als-loader' role='status' aria-live='polite' aria-busy={loading}>
            <img src={ImgLoader} alt="" />           
        </div>
    </>:null
}

export default LoaderCe